import { props as dialogProps } from "#ce/components/SpDialog/props.js";
import { booleanAttribute } from "#ce/utils/props";

// sp-bottom-sheet extends the sp-dialog prop contract with its own sizing props.
// Object.freeze() guards against accidental mutation (a bug we hit in the past).
export const props = Object.freeze({
  ...dialogProps,
  /**
   * Whether the bottom sheet should expand to maximum height.
   * If `true`, the bottom sheet will expand to maximum height.
   * The maximum height is defined by the `--sp-comp-bottom-sheet-content-max-height` CSS variable.
   *
   * @type {Boolean|String}
   * @default false
   */
  expandHeightMax: booleanAttribute(),

  /**
   * Whether the bottom sheet should expand to full height.
   * If `true`, the bottom sheet will expand to full height.
   *
   * @type {Boolean|String}
   * @default false
   */
  expandToFullHeight: booleanAttribute(),
  /**
   * Whether the bottom sheet should have no content padding.
   * If `true`, the bottom sheet will have no content padding.
   *
   * @type {Boolean|String}
   * @default false
   */
  noContentPadding: booleanAttribute(),
});
